import { render } from "./myAssets.vue?vue&type=template&id=05a45d0f&scoped=true"
import script from "./myAssets.vue?vue&type=script&lang=js"
export * from "./myAssets.vue?vue&type=script&lang=js"

import "./myAssets.vue?vue&type=style&index=0&id=05a45d0f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05a45d0f"]])

export default __exports__